<div class="container" [ngClass]="{ mobile: (isMobile$ | async) }">
  <h2 class="bold">{{ 'WM_TECH_POOL.FEES.TITLE' | translate }}</h2>

  <div class="fees-block">
    <h3 class="bold">{{ 'WM_TECH_POOL.FEES.SUBTITLE' | translate }}</h3>

    <div class="table-wrapper" [ngClass]="{ 'mat-small': (isMobile$ | async) }">
      <table>
        <tr>
          <th>{{ 'WM_TECH_POOL.FEES.TABLE.MODE' | translate }}</th>
          <th>{{ 'WM_TECH_POOL.FEES.TABLE.COMMISSIONS' | translate }}</th>
          <th>{{ 'WM_TECH_POOL.FEES.TABLE.PAYOUT' | translate }}</th>
        </tr>
        <tr>
          <td>{{ 'WM_TECH_POOL.FEES.TABLE.MODE1' | translate }}</td>
          <td>
            <span [class.blured-text]="!fees"> {{ fees?.value }}% </span>
          </td>
          <td>{{ 'WM_TECH_POOL.FEES.TABLE.PAYOUT1' | translate }}</td>
        </tr>
        <tr>
          <td>{{ 'WM_TECH_POOL.FEES.TABLE.MODE2' | translate }}</td>
          <td>
            <span [class.blured-text]="!fees"> {{ fees?.value }}% </span>
          </td>
          <td>{{ 'WM_TECH_POOL.FEES.TABLE.PAYOUT2' | translate }}</td>
        </tr>
      </table>
    </div>

    <div class="caption-block">
      <div class="left">
        <h4 class="bold">{{ 'WM_TECH_POOL.FEES.CAPTION.TITLE1' | translate }}</h4>
        <p class="mat-caption">{{ 'WM_TECH_POOL.FEES.CAPTION.TEXT1' | translate }}</p>
      </div>

      <div class="right">
        <h4 class="bold">{{ 'WM_TECH_POOL.FEES.CAPTION.TITLE2' | translate }}</h4>
        <p class="mat-caption">{{ 'WM_TECH_POOL.FEES.CAPTION.TEXT2' | translate }}</p>
      </div>
    </div>
  </div>

  <app-partners></app-partners>
</div>
